import { render, staticRenderFns } from "./WhatsappComposer.vue?vue&type=template&id=6bf65489&scoped=true&"
import script from "./WhatsappComposer.vue?vue&type=script&lang=js&"
export * from "./WhatsappComposer.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappComposer.vue?vue&type=style&index=0&id=6bf65489&lang=scss&scoped=true&"
import style1 from "./WhatsappComposer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf65489",
  null
  
)

export default component.exports